import React, { StrictMode, useEffect } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, useLocation } from "react-router-dom";

import "./reset.css";
import "./i18n.ts";
import i18n from "./i18n.ts";

import { ScrollToTop } from "./Components/ScrollToTop.jsx";
import Loading from "./Components/loading.js";
import { Router } from "./router.jsx";
import Social from "./Components/Sociais/Social.jsx";
import Header from "./Components/Header/Header.jsx";
import Footer from "./Components/Footer/Footer.jsx";

function HtmlLangEffect() {
  useEffect(() => {
    const update = (lng) => document.documentElement.setAttribute("lang", lng);
    update(i18n.language);
    i18n.on("languageChanged", update);
    return () => i18n.off("languageChanged", update);
  }, []);
  return null;
}

function UnicodeNormalizeEffect() {
  useEffect(() => {
    const normalizeTextNodes = (root = document.body) => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const norm = node.textContent.normalize("NFC");
        if (node.textContent !== norm) node.textContent = norm;
      }
    };
    normalizeTextNodes();

    const observer = new MutationObserver(() => normalizeTextNodes());
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    return () => observer.disconnect();
  }, []);
  return null;
}

function AppContent() {
  const location = useLocation();
  const path = decodeURI(location.pathname);

  const isAnyIniciacaoPage = [
    "/iniciação-ifá",
    "/iniciação-ifá-meta",
    "/iniciacao-ifa",
    "/iniciacao-ifa-meta",
  ].includes(path);
  const isBookLaunchPage = path.replace(/\/$/, "").toLowerCase() === "/lancamento-erindilogun";
  const hasOwnLayout = isAnyIniciacaoPage || isBookLaunchPage;

  return (
    <>
      <UnicodeNormalizeEffect />
      <HtmlLangEffect />
      {!isBookLaunchPage && <Social />}

      {!hasOwnLayout && <Header />}

      <Loading />
      <Router />

      {!hasOwnLayout && <Footer />}

      {!isBookLaunchPage && <ScrollToTop />}
    </>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <StrictMode>
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  </StrictMode>
);
